module.exports = __webpack_public_path__ + "img/iconfont.b01dc786.svg";